/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, Button, Grid, TextField } from "@mui/material";
import {  toast } from "react-toastify";import { DeviceState } from "./Device";
import { UrlEnum } from "../../Utils/Utils";
import { getData } from "../../Services/getData";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useEffect, useState } from "react";

const deviceTypeArray = [
  {
    name: "Tablet",
    label: Vocabulary["Tablet"],
  },
  {
    name: "Phone",
    label: Vocabulary["Phone"],
  },
  {
    name: "Watch",
    label: Vocabulary["Watch"],
  },
  {
    name: "Laptop",
    label: Vocabulary["Laptop"],
  },
];

type DeviceGeneralInformationProps = {
  state: DeviceState;
  setState: (state: DeviceState) => void;
  setDevicesResponse: (devicesResponse: Array<any>) => void;
  setOpenChooseDevicesModal: (openChooseDevicesModal: boolean) => void;
  handleChangeState: (event: React.MouseEvent | any) => void;
  setLoading: (loading: boolean) => void;
};
export default function DeviceGeneralInformation(
  props: DeviceGeneralInformationProps
) {
  const {
    state,
    setState,
    setDevicesResponse,
    setOpenChooseDevicesModal,
    handleChangeState,
    setLoading,
  } = props;
  const notifyError = (message: string) => toast.error(message);
  const [categories, setCategories] = useState<Array<any>>([]);

  useEffect(() => {
    getCategories();
  }, []);

  /**
   *
   */
  async function getCategories() {
    getData(UrlEnum.categories).then((response) => {
      if (response && response.data) setCategories(response.data);
    });
  }

  /**
   *
   * @param event
   * @param newValue
   */
  function handleChangeDeviceType(event: any, newValue: any) {
    const newState = Object.assign({}, state) as any;
    if (newValue) newState.deviceType = newValue.name;
    else {
      newState.deviceType = "";
    }
    setState(newState);
  }

  /**
   *
   * @param event
   */
  function getInformationAboutDevice() {
    setLoading(true);
    const searchUrl = `${UrlEnum.searchGSMDevice}/${state.deviceName}`;
    getData(searchUrl)
      .then((response) => {
        if (response.data.length !== 0) {
          setDevicesResponse(response.data);
          setOpenChooseDevicesModal(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        notifyError(Vocabulary.noResultsFound);
      });
  }

  return (
    <Grid item xs={12} md={6} lg={6}>
       <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px 10px",
          gap: "10px",
        }}
      >
        <Autocomplete
          options={deviceTypeArray}
          value={
            Vocabulary[state.deviceType] ? Vocabulary[state.deviceType] : ""
          }
          freeSolo
          selectOnFocus
          handleHomeEndKeys
          renderInput={(params) => (
            <TextField
              {...params}
              label={Vocabulary.deviceType}
              variant="standard"
              required
            />
          )}
          onChange={(event, newValue) =>
            handleChangeDeviceType(event, newValue)
          }
        />

        <Autocomplete
          options={categories}
          getOptionLabel={(option: any) => option.name}
          value={state.category}
          freeSolo
          selectOnFocus
          handleHomeEndKeys
          renderInput={(params) => (
            <TextField
              {...params}
              label={Vocabulary.categories}
              variant="standard"
              required
            />
          )}
          onChange={(event, newValue) => {
            const newState = Object.assign({}, state) as any;
            newState.category = newValue;
            setState(newState);
          }}
        />

        <TextField
          type="text"
          name="manufacturer"
          label={Vocabulary.manufacturer}
          variant="standard"
          value={state.manufacturer}
          onChange={(e) => handleChangeState(e)}
          required
        />
        <TextField
          type="text"
          name="model"
          label={Vocabulary.model}
          variant="standard"
          value={state.model}
          onChange={(e) => handleChangeState(e)}
          required
        />
        <div style={{ display: "flex" }}>
          <TextField
            type="text"
            name="deviceName"
            label={Vocabulary.deviceName}
            variant="standard"
            fullWidth
            value={state.deviceName}
            onChange={(e) => handleChangeState(e)}
            required
          />
          <Button
            variant="contained"
            size="small"
            style={{
              margin: "10px 0px 5px 10px",
            }}
            onClick={getInformationAboutDevice}
          >
            {Vocabulary.search}
          </Button>
        </div>

        <TextField
          type="text"
          name="paymentMethod"
          label={Vocabulary.paymentMethod}
          variant="standard"
          value={state.paymentMethod}
          onChange={(e) => handleChangeState(e)}
          required
        />
      </div>
    </Grid>
  );
}
